import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export enum EnergyFlowInType {
  Accumulator = 'Accumulator',
  Photovoltaic = 'Photovoltaic',
  Grid = 'Grid',
}

export enum EnergyFlowOutType {
  Accumulator = 'Accumulator',
  Heatpump = 'Heatpump',
  Household = 'Household',
  Grid = 'Grid',
  PhotovoltaicsHeater = 'PhotovoltaicsHeater',
  VCS = 'VehicleChargingStation',
  Photovoltaic = 'Photovoltaic',
  DryContactHeatpump = 'DryContactHeatpump',
  DryContactGeneric = 'DryContactGeneric',
}

export const ENERGY_IN_FLOW_ITEM_TYPES: { [key: string]: string } = {
  Accumulator: '+INSTALLATIONS.INSTALLATION.ENERGY_FLOW.PANEL.WHAT_GOES_IN.BATTERY_DISCHARGING',
  Photovoltaic: '+INSTALLATIONS.INSTALLATION.ENERGY_FLOW.PANEL.WHAT_GOES_IN.PHOTOVOLTAIC',
  Grid: '+INSTALLATIONS.INSTALLATION.ENERGY_FLOW.PANEL.WHAT_GOES_IN.GRID_CONSUMPTION',
};

export const ENERGY_OUT_FLOW_ITEM_TYPES: { [key: string]: string } = {
  Accumulator: '+INSTALLATIONS.INSTALLATION.ENERGY_FLOW.PANEL.WHERE_IT_GOES.BATTERY_CHARGING',
  Grid: '+INSTALLATIONS.INSTALLATION.ENERGY_FLOW.PANEL.WHERE_IT_GOES.GRID_FEED_IN',
  Household: '+INSTALLATIONS.INSTALLATION.ENERGY_FLOW.PANEL.WHERE_IT_GOES.HOUSEHOLD',
  Heatpump: '+INSTALLATIONS.INSTALLATION.ENERGY_FLOW.PANEL.WHERE_IT_GOES.HEAT_PUMP',
  VehicleChargingStation: '+INSTALLATIONS.INSTALLATION.ENERGY_FLOW.PANEL.WHERE_IT_GOES.VCS',
  PhotovoltaicsHeater:
    '+INSTALLATIONS.INSTALLATION.ENERGY_FLOW.PANEL.WHERE_IT_GOES.PV_IMMERSION_HEATER',
  DryContactHeatpump: '+INSTALLATIONS.INSTALLATION.ENERGY_FLOW.PANEL.WHERE_IT_GOES.HEAT_PUMP',
};

export enum EnergyFlowDirections {
  In = 'energyIn',
  Out = 'energyOut',
}

@Pipe({
  name: 'translateEnergyFlowType',
})
export class TranslateEnergyFlowTypePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(
    flowItem: string,
    energyFlowDirection: EnergyFlowDirections = EnergyFlowDirections.In
  ): string {
    if (flowItem) {
      if (
        energyFlowDirection === EnergyFlowDirections.Out &&
        ENERGY_OUT_FLOW_ITEM_TYPES[flowItem]
      ) {
        return this.translateService.instant(ENERGY_OUT_FLOW_ITEM_TYPES[flowItem]);
      }
      if (energyFlowDirection === EnergyFlowDirections.In && ENERGY_IN_FLOW_ITEM_TYPES[flowItem]) {
        return this.translateService.instant(ENERGY_IN_FLOW_ITEM_TYPES[flowItem]);
      }
    }

    return flowItem;
  }
}
